import React, { useEffect, Fragment, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  BulkImportCountry,
  StoreCountry
} from "../../../api/masters/countryAPI";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import BulkImport from "../../../components/BulkImport";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required")
});

const AddCountry = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await StoreCountry(data);
      if (response.success) {
        showToast("success", response.message);
        navigate(`/masters/country/list`);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  const bulkColumns = [{ key: "name", label: "Country Name", sample: "India" }];

  const handleBulkImport = async payload => {
    const response = await BulkImportCountry(payload);

    if (response.success) {
      showToast("success", response.message);
      navigate("/masters/country/list");
    } else {
      showToast("error", response.message);
    }
  };

  return (
    <Fragment>
      <Breadcrumb parent="Country" title="Add Country" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Countries</h5>
                  <Link to={`/masters/country/list`}>
                    <button className="btn btn-primary" id="list">
                      List Country
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Country
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Country Name*</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Country Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
            <BulkImport
              columns={bulkColumns}
              onSubmit={handleBulkImport}
              payloadKey="countries"
              sampleFileName="country_sample.csv"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddCountry;
